import usePrice from '@framework/product/use-price'
import { useTranslation } from 'next-i18next'
import {
  createPricePayload,
  getCurrentPrice,
  getDiscountedPrice,
  getOldPrice,
} from '@utils/helper'
import { useRouter } from 'next/router'
import { useContext } from 'react'
import { UserContext } from '@contexts/user/user.context'
import { IUser } from '@contexts/user/user.utils'
import { useSession } from 'next-auth/react'

export default function ProductPrice({ data }: any) {
  const { user } = useContext(UserContext) as IUser
  const { data: session } = useSession()
  const caseType = ['case']
  const { t } = useTranslation('common')

  const currentPrice = getCurrentPrice(createPricePayload(data))
  const oldPrice = getOldPrice(createPricePayload(data))
  const catalogRulePrice = data?.catalog_rule_price
  const tierPrices = data?.mag_attributes?.find(
    (attr: { attribute_code: string }) => attr.attribute_code === 'tier_prices',
  )?.value
  const finalCurrentPrice = getDiscountedPrice(
    user?.group_id,
    catalogRulePrice,
    currentPrice,
    session,
    tierPrices,
  )

  const { price: formattedCurrentPrice } = usePrice({
    amount: finalCurrentPrice,
    baseAmount: data.price,
    currencyCode: process.env.NEXT_PUBLIC_CURRENCY_CODE || 'USD',
  })

  const { price: formattedOldPrice } = usePrice({
    amount: oldPrice ?? 0, // If old price is null, pass 0 to the hook
    baseAmount: data.price,
    currencyCode: process.env.NEXT_PUBLIC_CURRENCY_CODE || 'USD',
  })
  const router = useRouter()
  const { locale } = router

  const convertCurrency = (price) => {
    // Remove the $ sign, replace '.' with ',', and append the $ sign at the end
    return price.replace('$', '').replace('.', ',') + ' $'
  }

  return (
    <div className="flex items-center mt-2">
      <div className="text-brand font-bold text-2xl md:text-4xl pr-1 [@media_(max-width:576px)]:text-lg ">
        {formattedCurrentPrice}
        <span className="[@media_(max-width:576px)]:text-sm text-[20px] font-normal">
          /{data?.sold_as}
        </span>
      </div>
      {oldPrice && (
        <div className="-mb-2">
          <del className="[@media_(max-width:576px)]:text-sm  text-xl font-medium md:text-[20px] ltr:pl-1 rtl:pr-3 text-brand-gray">
            {formattedOldPrice}
          </del>
        </div>
      )}
      {/* Uncomment and modify as needed for discount display */}
      {/* <span className="inline-block rounded font-bold text-xs md:text-sm bg-brand-tree bg-opacity-20 text-brand-tree uppercase px-2 py-1 ltr:ml-2.5 rtl:mr-2.5">
          {discount} {t('text-off')}
      </span> */}
      {/* Uncomment and modify radio box display as needed */}
      {/* <div className="inline-flex">
        <ProductRadioBox label="case" checked={caseType.includes('case')} />
        <ProductRadioBox label="each" checked={caseType.includes('each')} />
      </div> */}
    </div>
  )
}
